export default __webpack_public_path__ + "static/media/password-code.2d131994.png";